export default "__VITE_ASSET__DP3UyJ9a__"